import resfult from "@/services/resful.js";
export const service = {
  getFormInfo: async function(data, next) {
    let res = await resfult.get("/app/google-form?url=" + data.url, data);
    next(res);
  }
};
